/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sla_SettingsInputs */

const vi_nav_sla_settings = /** @type {(inputs: Nav_Sla_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cài đặt SLA`)
};

/**

* @param {Nav_Sla_SettingsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_sla_settings = /** @type {((inputs?: Nav_Sla_SettingsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sla_SettingsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_sla_settings(inputs)
});